<ng-template #template>
  @let colData = data();
  @for (col of columns(); track col.field) {
    @if(!col.hide) {
      <td [class]="col.columnClass" [style]="styles()[col.field]" pFrozenColumn [frozen]="col.frozen ?? false">
        <span class="p-column-title">{{col.header}}</span>

        <span [pTooltip]="col.includeTooltip ? tooltipValues()[col.field] : undefined" [tooltipPosition]="col.includeTooltip ? (col.tooltipPosition ?? 'right') : undefined">

          @if(col.type === 'date') {
            {{colData[col.field] | date: col.dateFormat ?? 'MM/dd/yyyy'}}
            @if (col.installmentSummaryField) {
              @let installmentSummary = colData[col.installmentSummaryField];
              @if (installmentSummary) {
                ({{installmentSummary.remaining}} of {{installmentSummary.total}} left)
              }
            }
          }
          @else if(col.type === 'currency') {
          <div class="flex justify-end">{{colData[col.field] | currency: 'USD': 'symbol':'1.2-2'}}</div>
        }
        @else if(col.type === 'boolean') {
        @if(col.severityMap) {
          @let severity = colData[col.field] ? 'true' : 'false';
          <p-tag [severity]="resolveTagSeverity(col?.severityMap![severity])">{{colData[col.field] ? col.trueValue ?? 'Yes' : col.falseValue
          ?? 'No'}}</p-tag>
        }
        @else {
        {{colData[col.field] ? col.trueValue ?? 'Yes' : col.falseValue ?? 'No'}}
      }
    }
    @else if(col.type === 'percentage') {
    <div class="flex justify-end">{{formatPercentage(colData[col.field])}}</div>
  }
  @else if(col.type === 'html') {
  <div class="truncate-cell">
    @if (!colData['expanded_' + col.field]) {
      <div>
        <span class="prose prose-sm dark:prose-invert"
        [innerHtml]="(colData[col.field]?.length > 200 ? (colData[col.field]?.substring(0, 200) + '...') : colData[col.field]) | sanitizeHtml"></span>
        @if(colData[col.field]?.length > 200) {
          <button type="button" class="expand-btn" (click)="colData['expanded_' + col.field] = true">Read
          More</button>
        }
      </div>
    }
    @if (colData['expanded_' + col.field]) {
      <div>
        <span class="prose prose-sm dark:prose-invert" [innerHTML]="colData[col.field]"></span>
        <button type="button" class="expand-btn" (click)="colData['expanded_' + col.field] = false">Read
        Less</button>
      </div>
    }
  </div>
}
@else if (col.type === 'groupNameWithLink') {
@if (colData[col.custIdField]) {
  <a [href]="colData[col.custIdField] | contactCardUrl:colData[col.tripIdField ?? 'tripId']:col.fragment"
    target="_blank"
  class="text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 hover:underline font-medium transition-colors duration-200">{{colData[col.field]}}</a>
}
@else {
{{colData[col.field]}}
}
}
@else if (col.type === 'tripIdWithLink') {
@if(colData[col.custIdField]) {
  <a [href]="colData[col.custIdField] | contactCardUrl:colData[col.tripIdField]:col.fragment" target="_blank"
    class="text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 hover:underline font-medium transition-colors duration-200">
    {{colData[col.field]}}
  </a>
} @else {
  {{colData[col.field]}}
}
}

@else if(col.type === 'groupIdWithLink') {
@if(colData[col.custIdField]) {
  <a [href]="colData[col.custIdField] | contactCardUrl:undefined" target="_blank"
    class="text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 hover:underline font-medium transition-colors duration-200">
    {{colData[col.field]}}
  </a>
} @else {
  {{colData[col.field]}}
}
}

@else if (col.type === 'partnerNameWithLink') {
@if (colData[col.partnerIdField]) {
  <a [href]="colData[col.partnerIdField] | rootsUrlPipe" target="_blank"
  class="text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 hover:underline font-medium transition-colors duration-200">{{colData[col.field]}}</a>
}
@else {
{{colData[col.field]}}
}
}

@else if (col.type === 'linkToPpm') {
@if(colData[col.linkField]) {
  <a href="https://www.ppm.org{{colData[col.field]}}" target="_blank"
  class="text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 hover:underline font-medium transition-colors duration-200">{{colData[col.field]}}</a>
} @else {
  {{colData[col.field]}}
}
}

@else if (col.type === 'webcastWithUrl') {
@if (colData[col.field] === 1 || colData[col.field] === '1') {
  @if (colData[col.linkField]) {
    <a [href]="colData[col.linkField] | externalUrl" target="_blank"
    class="text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 hover:underline font-medium transition-colors duration-200">{{colData[col.linkField]}}</a>
  } @else {
    Yes
  }
} @else {
  No
}
}

@else if (col.type === 'logtype') {
<span>
  @switch (colData[col.field] ?? 1) {
    @case (0) {
      <fa-icon [icon]="icons.solid.faDesktop" pTooltip="System"></fa-icon>
    }
    @case (1) {
      <fa-icon [icon]="icons.solid.faFileText" pTooltip="Note"></fa-icon>
    }
    @case (2) {
      <fa-icon [icon]="icons.regular.faEnvelope" pTooltip="Message"></fa-icon>
    }
    @case (3) {
      <fa-icon [icon]="icons.solid.faEnvelope" pTooltip="Customer Service"></fa-icon>
    }
    @case (4) {
      <fa-icon [icon]="icons.solid.faPhone" pTooltip="Call"></fa-icon>
    }
    @case (5) {
      <fa-icon [icon]="icons.regular.faComments" pTooltip="Email or Text"></fa-icon>
    }
    @case (6) {
      <fa-icon [icon]="icons.solid.faTasks" pTooltip="Task"></fa-icon>
    }
    @case (7) {
      <fa-icon [icon]="icons.solid.faCoffee" pTooltip="In-person Meeting"></fa-icon>
    }
    @default {
      <fa-icon [icon]="icons.solid.faFileText" pTooltip="Note"></fa-icon>
    }
  }
</span>
}

@else if (col.type === 'groupArray') {
@let data = colData[col.field];

<div class="flex flex-col">

  @for (customerInfo of data; track $index) {

    @if (col.displayField === 'custId') {
      <a [href]="customerInfo.custId | contactCardUrl:customerInfo.tripId:col.fragment" target="_blank"
      class="text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 hover:underline font-medium transition-colors duration-200">{{customerInfo.custId}}</a>
    }
    @else {
    <a [href]="customerInfo.custId | contactCardUrl:customerInfo.tripId:col.fragment" target="_blank"
    class="text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 hover:underline font-medium transition-colors duration-200">{{customerInfo.groupName}}</a>
  }
}
</div>
}

@else if (col.type === 'chip') {
<div class="flex flex-wrap gap-2 justify-center">
  @let data = colData[col.field];
  @if (isArray(data)) {
    @for (item of data; track $index) {
      @if (col.severityMap) {
        @let severity = col.severityMapField ? colData[col.severityMapField] : item;
        <p-tag [severity]="resolveTagSeverity(col?.severityMap![severity])">{{item | titlecase}}</p-tag>
      }
      @else {
      <p-tag>{{item | titlecase}}</p-tag>
    }
  }
}
@else {
@if (col.severityMap) {
  @let severity = col.severityMapField ? colData[col.severityMapField] : colData[col.field];
  <p-tag [severity]="resolveTagSeverity(col?.severityMap![severity])">{{colData[col.field] | titlecase}}</p-tag>
}
@else {
<p-tag>{{colData[col.field] | titlecase}}</p-tag>
}
}
</div>
}
@else if (col.type === 'number') {
<div class="flex justify-end">
  @if(col.pipeParams) {
    {{colData[col.field] | number: col.pipeParams}}
  }
  @else {
  {{colData[col.field]}}

}
</div>
}
@else if (col.type === 'link') {
@if(col.field === 'nsNum') {
  @if(colData[col.linkField] && colData[col.linkField] !== '' && colData[col.field] && colData[col.field] !== 0) {
        <a [href]="'https://system.netsuite.com/app/common/entity/custjob.nl?id=' + colData[col.linkField]"
            [target]="col.target ?? '_blank'"
    class="text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 hover:underline font-medium transition-colors duration-200">{{colData[col.field]}}</a>
  }
  @else {
  {{colData[col.field]}}
}
}
@else if(colData[col.linkField]) {
<a [href]="colData[col.linkField] | externalUrl" [target]="col.target ?? '_blank'"
  class="text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 hover:underline font-medium transition-colors duration-200">{{col.staticText
?? colData[col.field]}}</a>
}
@else {
{{colData[col.field]}}
}
}
@else if (col.type === 'phone') {
@if(colData[col.field]) {
  <a [href]="'tel:' + colData[col.field]"
  class="text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 hover:underline font-medium transition-colors duration-200">{{colData[col.field]}}</a>
}
@else {
{{colData[col.field]}}
}
}
@else if (col.type === 'email') {
@if(colData[col.field]) {
  <a [href]="'mailto:' + colData[col.field]"
  class="text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 hover:underline font-medium transition-colors duration-200">{{colData[col.field]}}</a>
}
@else {
{{colData[col.field]}}
}
}
@else if (col.type === 'text' || col.type === 'string') {
<span

  [class.cursor-pointer]="col.clickeable" [class.text-primary-600]="col.clickeable"
  [class.dark:text-primary-400]="col.clickeable" [class.hover:underline]="col.clickeable"
  (click)="col.clickeable ? onCellClick(col, colData[col.field], $event) : null">
  @if(col.html) {
    <span class="prose dark:prose-invert" [innerHtml]="colData[col.field] | sanitizeHtml"></span>
  }
  @else {
  {{colData[col.field]}}
}
</span>
}
@else if (col.type === 'fraction') {
{{colData[col.field]}} / {{colData[col.denominatorField]}}
}
@else if (col.type === 'list') {
@let data = colData[col.field];
@if (isArray(data)) {
  <div class="flex flex-col">
    @for (item of data; track $index) {

      <div [class]="item.class ? 'flex justify-between w-full ' +item.class : 'flex justify-between w-full'">
        <label class="font-bold">{{item.label}}</label>
        <div>{{item.value}}</div>
      </div>

    }
  </div>
}
}
@else {
{{colData[col.field]}}
}
</span>
</td>
} }
</ng-template>